import { Component, OnInit, Input } from '@angular/core';
import { ClientesService } from '../../../services/Clientes.service';
import { FormGroup, FormControl } from '@angular/forms';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { RutasService } from '../../../services/rutas.service';
// Ngb
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
@Component({
  selector: 'app-acceso-cliente',
  templateUrl: './acceso-cliente.component.html',
  styleUrls: ['./acceso-cliente.component.css']
})
export class AccesoClienteComponent implements OnInit {
  @Input() empleado;
  @Input() modals;
  clientes = [];
  clientesSeleccionado = [];
  rutas = [];
  form: FormGroup;
  loading = false;
  next: boolean;
  fechaPago = {
    year: parseFloat(moment().format('Y')),
    month: parseFloat(moment().format('MM')),
    day: parseFloat(moment().format('DD'))
  };
  constructor(
    private clienteService: ClientesService,
    private empleadoService: EmpleadosServicio,
    public activeModal: NgbActiveModal,
    private rutasService: RutasService) {
      this.initForm();
  }

  ngOnInit() {
    this.form.get('empleado').setValue(this.empleado.ID_EMPLEADO);
    this.initRutas();
  }

  private initForm(): void {

    // Inicializar formulario
    this.form = new FormGroup({
      'nombre': new FormControl(''),
      'cedula': new FormControl(''),
      'telefono': new FormControl(''),
      'ruta': new FormControl(''),
      'direccion': new FormControl(''),
      'empleado': new FormControl('')
    });
  }

  private initClientes(): void {
    this.clienteService.accesoCliente(this.form.value)
    .subscribe(res => {
      if (res) {
        for (const row of res.clientes) {
          for (const seleccionado of this.clientesSeleccionado) {
            if (row.id === seleccionado.id && seleccionado.checked) {
              row.checked = true;
              break;
            }
          }
        }
        this.clientes = res.clientes;
      }
    });
  }

  filtrarClientes(): void {
    this.initClientes();
  }

  guardar() {
    if (!this.loading && this.clientesSeleccionado.length) {
      const a = this.clientesSeleccionado.map(row => `${row.nombre} ${row.apellido}`);
      const html = `¿Estas seguro de conceder el acceso al empleado <b>${this.empleado.nombre} ${this.empleado.apellido}</b> la información ${a.length > 1 ? 'de los clientes:' : 'del cliente'} <b>${a.slice(0, -1).join(',')+`${a.length > 1 ? ' y ' : ''}`+a.slice(-1)}</b>?`;
      this.modals.confirmModalJquery('¿Estas seguro?', html, 'orange', 'material')
      .then(resp => {
        if (resp && resp === 'SI') {
          const { year, month, day } = this.fechaPago;
          const data = {
            ID_EMPLEADO: this.empleado.ID_EMPLEADO,
            clientes: this.clientesSeleccionado.map(row => row.id),
            autorizadoPor: this.empleadoService.datosEmpleado.ID_EMPLEADO,
            fecha_extraordinaria: `${year}-${month}-${day}`
          };
          this.loading = true;
          this.clienteService.darAccesoCliente(data)
          .subscribe(res => {
            if (res) {
              this.modals.correctoModalJquery('Acceso concedido', 'green', 'modern', 'fa fa-unlock');
              this.activeModal.dismiss();
            }
            this.loading = false;
          }, err => {
            this.loading = false;
            if (err) {
              if (err.status === 401) {
                this.modals.validacionesModalJquery('Error', err.error, 'red', 'modern');
              }
            }
          });
        }
      });
    }
  }

  private initRutas(): void {
    this.rutasService.cargarTodasLasRutas()
    .subscribe(res => {
      this.rutas = res.rutas;
      this.initClientes();
    });
  }

  pushClientesSelect(cliente) {
    const indexOf = this.clientesSeleccionado.indexOf(cliente);
    cliente.checked = !cliente.checked;
    if (indexOf > -1) {
      this.clientesSeleccionado.splice(indexOf, 1);
    } else {
      this.clientesSeleccionado.push(cliente);
    }
  }
  
  pushTodosClientesSelect() {
    this.clientesSeleccionado = [];
    for (const row of this.clientes) {
      row.checked = true;
    }
    this.clientesSeleccionado.push(...this.clientes);
  }

  desmarcarTodos() {
    for (const cliente of this.clientes) {
      cliente.checked = false;
    }
    this.clientesSeleccionado = [];
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/acceso-cliente/acceso-cliente.component.ts